(function () {
  'use strict';

  function init() {
    var banner = document.querySelector('[data-hk-cookie]');
    var accept = document.querySelector('[data-hk-cookie-accept]');
    var reject = document.querySelector('[data-hk-cookie-reject]');
    var manage = document.querySelector('[data-hk-cookie-manage]');
    if (!banner || !accept || !reject || !manage || !window.Shopify || !Shopify.loadFeatures) return;

    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error || !Shopify.customerPrivacy) return;

      var privacy = Shopify.customerPrivacy;
      var current = privacy.currentVisitorConsent ? privacy.currentVisitorConsent() : {};
      var undecided = !current || [current.analytics, current.marketing, current.preferences].some(function (value) { return value === ''; });
      var shouldShow = privacy.shouldShowBanner ? privacy.shouldShowBanner() : undecided;

      function setOpen(open) {
        banner.hidden = !open;
        manage.hidden = open;
      }

      function submit(value) {
        accept.disabled = true;
        reject.disabled = true;
        privacy.setTrackingConsent({ analytics: value, marketing: value, preferences: value }, function () {
          setOpen(false);
          accept.disabled = false;
          reject.disabled = false;
          document.dispatchEvent(new CustomEvent('visitorConsentCollected'));
        });
      }

      accept.addEventListener('click', function () { submit(true); });
      reject.addEventListener('click', function () { submit(false); });
      manage.addEventListener('click', function () { setOpen(true); });
      setOpen(Boolean(shouldShow || undecided));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
